import { useState, useEffect } from "react";
import { Collapse, Spin } from "antd";

import API from "scripts/api";
import Resources from "scripts/resources";

import CuriousMan from "images/curiousman.png";
import GoldKey from "images/goldenkey.png";

const Component = () => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { data, loaded } = state;

	const componentDidMount = () => {
		API.faq()
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					loaded: true,
					data,
				}));
			})
			.catch();

		document.title = Resources.faq;
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<div className="page-faq">
			<div className="container">
				<img
					src={CuriousMan}
					alt={Resources.faq}
					className="image"
				/>
				<h1 className="heading">
					<img
						src={GoldKey}
						alt={Resources.goldenKey}
					/>
					{Resources.faq}
				</h1>
				<Collapse>
					{data.map(({ answer, question }, i) => (
						<Collapse.Panel
							key={i}
							header={
								<>
									<span className="index">{i + 1}</span>
									{question}
								</>
							}
						>
							<div dangerouslySetInnerHTML={{ __html: answer }} />
						</Collapse.Panel>
					))}
				</Collapse>
			</div>
		</div>
	) : (
		<Spin className="page-loading" />
	);
};

export default Component;
